"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var log_client_1 = require("@classdojo/log-client");
function makeKey(metricName, tags) {
    if (!tags)
        return metricName;
    return Object.keys(tags)
        .sort()
        .map(function (key) {
        return "".concat(key, ":").concat(tags[key]);
    })
        .concat(metricName)
        .join("|");
}
var DEFAULT_CONFIG = {
    flushInterval: 15000,
};
function LogClientBackend(customConfig) {
    //
    // Storage for unsent entries.
    //
    var countersInProgress = {};
    var gaugesInProgress = {};
    var distributions = [];
    function flush() {
        var metricsToSend = [];
        Object.values(countersInProgress).forEach(function (_a) {
            var metricName = _a.metricName, value = _a.value, tags = _a.tags;
            metricsToSend.push({
                metricName: metricName,
                type: "increment",
                value: value,
                tags: tags,
            });
        });
        countersInProgress = {};
        Object.values(gaugesInProgress).forEach(function (_a) {
            var metricName = _a.metricName, values = _a.values, tags = _a.tags;
            metricsToSend.push({
                metricName: metricName,
                type: "gauge",
                value: values.reduce(function (acc, next) { return acc + next; }, 0) / values.length,
                tags: tags,
            });
        });
        gaugesInProgress = {};
        Object.values(distributions).forEach(function (_a) {
            var metricName = _a.metricName, value = _a.value, tags = _a.tags;
            metricsToSend.push({
                metricName: metricName,
                type: "distribution",
                value: value,
                tags: tags,
            });
        });
        distributions = [];
        if (!metricsToSend.length) {
            return;
        }
        (0, log_client_1.sendMetrics)(metricsToSend);
    }
    //
    // These functions will be exported.
    //
    function increment(metricName, value, tags) {
        var key = makeKey(metricName, tags);
        var bucket = countersInProgress[key];
        if (!bucket) {
            countersInProgress[key] = {
                metricName: metricName,
                tags: tags,
                value: value,
            };
        }
        else {
            bucket.value += value;
        }
    }
    function gauge(metricName, value, tags) {
        var key = makeKey(metricName, tags);
        var bucket = gaugesInProgress[key];
        if (!bucket) {
            gaugesInProgress[key] = {
                metricName: metricName,
                tags: tags,
                values: [value],
            };
        }
        else {
            bucket.values.push(value);
        }
    }
    function distribution(metricName, value, tags) {
        distributions.push({
            metricName: metricName,
            value: value,
            tags: tags,
        });
    }
    function event(_eventName, _type, _tags) {
        throw new Error("'event' not implemented for logClient backend");
    }
    //
    // Start everything up
    //
    var interval = setInterval(flush, customConfig && customConfig.flushInterval
        ? customConfig.flushInterval
        : DEFAULT_CONFIG.flushInterval);
    return {
        increment: increment,
        gauge: gauge,
        timing: gauge,
        histogram: gauge,
        distribution: distribution,
        event: event,
        close: function () {
            flush();
            clearInterval(interval);
        },
    };
}
exports.default = LogClientBackend;
//# sourceMappingURL=logClient.js.map